import { render, staticRenderFns } from "./ProfessorTurmas.vue?vue&type=template&id=a370dac4&"
import script from "./ProfessorTurmas.vue?vue&type=script&lang=js&"
export * from "./ProfessorTurmas.vue?vue&type=script&lang=js&"
import style0 from "./ProfessorTurmas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports